export function successSlider() {
    const $slider = $(".success-slider");
    let isAutoplay = false;
    let isInfinite = false;
    let speed = parseInt($slider.data('speed'));

    if (speed) {
        isAutoplay = true;
        isInfinite = true;
    }

    $slider.slick({
        slidesToScroll: 1,
        slidesToShow: 1.15,
        mobileFirst: true,
        infinite: isInfinite,
        autoplay: isAutoplay,
        autoplaySpeed: speed,
        speed: 500,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/successSlider.js